// Shared utility functions for Pulse components

export function formatNumber(n: number, decimals = 2): string {
  if (Math.abs(n) >= 1_000_000_000_000) {
    return `${(n / 1_000_000_000_000).toFixed(1)}T`;
  }
  if (Math.abs(n) >= 1_000_000_000) {
    return `${(n / 1_000_000_000).toFixed(1)}B`;
  }
  if (Math.abs(n) >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(1)}M`;
  }
  if (Math.abs(n) >= 1_000) {
    return `${(n / 1_000).toFixed(1)}K`;
  }
  return n.toFixed(decimals);
}

export function formatPrice(n: number): string {
  if (n >= 1000) return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (n >= 1) return n.toFixed(2);
  return n.toFixed(4);
}

export function formatPercent(n: number): string {
  const sign = n >= 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
}

export function formatVolume(n: number): string {
  return formatNumber(n, 0);
}

export function changeColor(val: number): string {
  if (val > 0) return "text-accent-400";
  if (val < 0) return "text-red-400";
  return "text-surface-400";
}

export function changeBg(val: number): string {
  if (val > 0) return "bg-accent-500/10";
  if (val < 0) return "bg-red-500/10";
  return "bg-surface-800/50";
}

export function timeAgo(timestamp: number): string {
  const now = Date.now() / 1000;
  const diff = now - timestamp;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function marketStateLabel(state: string): string {
  switch (state) {
    case "REGULAR": return "Open";
    case "PRE": return "Pre-Market";
    case "POST": return "After Hours";
    case "PREPRE": return "Pre-Market";
    case "POSTPOST": return "Closed";
    case "CLOSED": return "Closed";
    default: return state;
  }
}

export function marketStateDot(state: string): string {
  switch (state) {
    case "REGULAR": return "bg-accent-400";
    case "PRE":
    case "POST": return "bg-yellow-400";
    default: return "bg-surface-500";
  }
}
